/**
 * Nájdenie workflow stavu v crm_states (parita FP getIdByName / phase+transition).
 */

export function findCrmWorkflowStateId(crmStates, phase, transitionType, sortOrder = 1) {
  const list = Array.isArray(crmStates) ? crmStates : [];
  const row = list.find(
    (s) => String(s?.phase ?? '') === phase
      && String(s?.transition_type ?? '') === transitionType
      && Number(s?.sort_order ?? 0) === Number(sortOrder),
  );
  return row ? Number(row.id) : null;
}

export function findCrmStornoStateId(crmStates) {
  return findCrmWorkflowStateId(crmStates, 'closing', 'final_auto', 2);
}

export function findCrmClosedStateId(crmStates) {
  return findCrmWorkflowStateId(crmStates, 'closing', 'final_auto', 1);
}

export function findCrmReopenStateId(crmStates) {
  return findCrmWorkflowStateId(crmStates, 'closing', 'reopen', 1);
}

export function isCrmWorkflowClosedState(state) {
  if (!state) return false;
  const phase = String(state.phase ?? '');
  const transition = String(state.transition_type ?? '');
  if (phase === 'closing' && transition === 'final_auto') return true;
  if (phase === 'approval' && transition === 'final_manually') return true;
  return false;
}
